const backendIt = {
  auth_not_authenticated: 'Accedi per continuare.',
  auth_permission_denied_add_org: 'Non hai l’autorizzazione per aggiungere un’organizzazione.',
  payload_missing_required_fields: 'Mancano alcune informazioni obbligatorie.',
  organisation_invalid_type: 'Il tipo di organizzazione non è valido.',
  organisation_duplicate_owner_name: 'Esiste già un’organizzazione con questo nome.',
  organisation_create_failed: 'Impossibile creare l’organizzazione.',
  organisation_set_claims_failed_owner: 'Impossibile aggiornare le autorizzazioni del proprietario.',
  organisation_set_claims_failed_user: 'Impossibile aggiornare le autorizzazioni dell’utente.',
  organisation_add_failed: 'Impossibile aggiungere l’organizzazione.',
  organisation_not_found: 'Impossibile trovare questa organizzazione.',
  organisation_missing_fields: 'Alla scheda dell’organizzazione mancano dati obbligatori.',
  onboarding_not_new_user: 'Questo account ha già completato l’onboarding.',
  onboarding_unknown_error: 'Si è verificato un errore durante il completamento dell’onboarding.',
  email_invalid_argument: 'Inserisci un indirizzo e-mail valido.',
  email_already_verified: 'Questa e-mail è già stata verificata.',
  email_no_data: 'Impossibile preparare l’e-mail di verifica.',
  email_sending_failed: 'Impossibile inviare l’e-mail. Riprova più tardi.',
  email_verification_failed: 'Impossibile inviare una nuova e-mail di verifica.',
  promoter_not_found: 'Impossibile trovare questo promoter.',
  promoter_missing_claims: 'Il profilo del promoter è incompleto.',
  password_strength_failed: 'Scegli una password più sicura che soddisfi tutti i requisiti.',
  invitation_invalid_token: 'Il tuo link di invito non è valido o è scaduto. Apri l’e-mail di invito più recente.',
  invitation_not_found: 'Impossibile trovare questo invito.',
  invitation_not_pending: 'Questo invito non è più in attesa.',
  invitation_missing_id: 'Manca il riferimento dell’invito.',
  invitation_public_cancel_denied: 'Gli inviti pubblici non possono essere annullati.',
  invitation_not_inviter: 'Solo chi ha inviato l’invito può gestirlo.',
  invitation_not_inviter_or_delegate: 'Solo chi ha inviato l’invito o il suo delegato può gestirlo.',
  invitation_promoter_not_public: 'Questo promoter non accetta inviti pubblici.',
  invitation_invalid_email_format: 'Inserisci un’e-mail e una password valide.',
  invitation_invalid_role_division: 'Il ruolo o la divisione selezionata non è consentita.',
  invitation_already_accepted: 'Questa persona ha già accettato un invito.',
  invitation_email_in_use: 'Questa e-mail è già registrata.',
  invitation_create_failed: 'Impossibile creare l’invito.',
  invitation_create_user_failed: 'Impossibile creare l’account utente.',
  invitation_create_user_ref_failed: 'Impossibile collegare l’account utente.',
  invitation_inviter_data_failed: 'Impossibile caricare i dati di chi ha invitato.',
  invitation_inviter_claims_failed: 'Impossibile caricare le autorizzazioni di chi ha invitato.',
  invitation_custom_claims_too_large: 'Le autorizzazioni dell’invito sono troppo estese.',
  invitation_invite_permission_denied: 'Non hai l’autorizzazione per invitare qualcuno.',
  invitation_fetch_failed: 'Impossibile caricare gli inviti.',
  invitation_user_missing_email: 'Il tuo account necessita di un indirizzo e-mail.',
  invitation_owner_missing: 'Impossibile trovare il proprietario del promoter.',
  invitation_role_not_authorized: 'Questo ruolo non è autorizzato a inviare inviti.',
  invitation_role_not_found: 'Impossibile trovare questo ruolo.',
  invitation_pending_exists: 'Esiste già un invito in corso per questa persona.',
  invitation_cancel_unknown: 'Impossibile annullare l’invito.',
  invitation_reject_unknown: 'Impossibile rifiutare l’invito.',
  invitation_request_unknown: 'Impossibile inviare la richiesta di invito.',
  verify_email_unknown: 'Impossibile verificare l’e-mail.',
  superuser_unauthorized: 'Solo i superutenti possono eseguire questa azione.',
  superuser_invitations_unknown: 'Impossibile caricare l’elenco degli inviti.',
  superuser_users_unknown: 'Impossibile caricare l’elenco degli utenti.',
  superuser_organisations_unknown: 'Impossibile caricare l’elenco delle organizzazioni.',
  signup_requires_auth: 'Accedi per continuare.',
  signup_unknown_error: 'Si è verificato un errore durante la creazione dell’account.',
  signup_update_password_failed: 'Impossibile aggiornare la password.',
  provider_already_exists: 'Questo provider esiste già.',
  custom_claims_set_failed: 'Impossibile aggiornare le autorizzazioni dell’account.',
} as const;

export default backendIt;
